module.exports = __webpack_public_path__ + "static/media/console-home-bg.9f6ce9b5.svg";